module.exports = __webpack_public_path__ + "img/avatar2.104f9863.png";